import React from 'react';
import {
    Checkbox,
    TableCell,
    TableRow
} from 'material-ui';
import {
    canAssignReviewsToSites
} from '../../../components/permissions/permissions';

const TableLanguagesInputs = ({
    site,  
    languages,  
    sitesLanguages, 
    changeSiteLanguage,  
    classes 
}) => ( 
    <TableRow hover={true}> 
        <TableCell className={classes.tableCell}>{site.display_name}</TableCell> 
        {languages.map(language => {
            const isChecked = sitesLanguages[site.id] != null && sitesLanguages[site.id][language.id] === true;
            const activeCheckbox = () => (
                <Checkbox 
                    checked={isChecked} 
                    onChange={(ev, checked) => changeSiteLanguage(site.id, language.id, checked)} 
                    name={'lang[' + site.id + '][' + language.id + ']'} 
                />
            )
            const disabledCheckbox = () => (
                <Checkbox
                    checked={isChecked}
                    className={classes.disabledCheckboxes}
                    disabled={true}
                    name={'lang[' + site.id + '][' + language.id + ']'}
                />
            )
            let ViewOrEditCheckboxes = canAssignReviewsToSites(activeCheckbox, disabledCheckbox);

            return ( 
                <TableCell key={language.id} className={classes.tableCellCenter}>
                    <ViewOrEditCheckboxes />
                </TableCell>
            )
        })}
    </TableRow>
)

export default TableLanguagesInputs;


// WEBPACK FOOTER //
// ./src/containers/configuration/forms/TableLanguagesInputs.jsx